import React from "react";

const getAppElement = () => document.querySelector(".app");

const wrapInRequestAnimationFrame = (callback: (scrollTop: number) => void) => {
    let tick = false;
    let lastScrollTop = -1;
    return () => {
        const appElement = getAppElement();
        lastScrollTop = appElement?.scrollTop ?? 0;
        if (!tick) {
            window.requestAnimationFrame(() => {
                callback(lastScrollTop);
                tick = false;
            });

            tick = true;
        }
    };
};

export const useScrollEffect = (
    onScrollEffects: (scrollTop: number) => void,
) => {
    React.useEffect(() => {
        const appElement = getAppElement();
        const onScroll = wrapInRequestAnimationFrame(onScrollEffects);
        appElement?.addEventListener("scroll", onScroll);
        return () => {
            appElement?.removeEventListener("scroll", onScroll);
        };
    }, []);
};
